module.exports = "https://static.wmbcdn.com/uniweb/images/9bbe396292c754dac193253132c2e33d.svg";